var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError400(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 115,
    viewBox: "0 0 137 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.186 21.6004C111.45 21.6004 113.286 19.7648 113.286 17.5004C113.286 15.236 111.45 13.4004 109.186 13.4004C106.922 13.4004 105.086 15.236 105.086 17.5004C105.086 19.7648 106.922 21.6004 109.186 21.6004Z",
    fill: "#F7C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2863 5.6C87.8327 5.6 89.0863 4.3464 89.0863 2.8C89.0863 1.2536 87.8327 0 86.2863 0C84.7399 0 83.4863 1.2536 83.4863 2.8C83.4863 4.3464 84.7399 5.6 86.2863 5.6Z",
    fill: "#9EB9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2863 5.6C87.8327 5.6 89.0863 4.3464 89.0863 2.8C89.0863 1.2536 87.8327 0 86.2863 0C84.7399 0 83.4863 1.2536 83.4863 2.8C83.4863 4.3464 84.7399 5.6 86.2863 5.6Z",
    fill: "#9EB9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2863 5.6C87.8327 5.6 89.0863 4.3464 89.0863 2.8C89.0863 1.2536 87.8327 0 86.2863 0C84.7399 0 83.4863 1.2536 83.4863 2.8C83.4863 4.3464 84.7399 5.6 86.2863 5.6Z",
    fill: "#9EB9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 85C31.8807 85 33 83.8807 33 82.5C33 81.1193 31.8807 80 30.5 80C29.1193 80 28 81.1193 28 82.5C28 83.8807 29.1193 85 30.5 85Z",
    fill: "#9EB9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 85C31.8807 85 33 83.8807 33 82.5C33 81.1193 31.8807 80 30.5 80C29.1193 80 28 81.1193 28 82.5C28 83.8807 29.1193 85 30.5 85Z",
    fill: "#9EB9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 85C31.8807 85 33 83.8807 33 82.5C33 81.1193 31.8807 80 30.5 80C29.1193 80 28 81.1193 28 82.5C28 83.8807 29.1193 85 30.5 85Z",
    fill: "#0BFFB7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7863 21.5004C15.3327 21.5004 16.5863 20.2468 16.5863 18.7004C16.5863 17.154 15.3327 15.9004 13.7863 15.9004C12.2399 15.9004 10.9863 17.154 10.9863 18.7004C10.9863 20.2468 12.2399 21.5004 13.7863 21.5004Z",
    fill: "#FFE664"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9544_25013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.177 21.7833V77.1881C114.177 79.4941 112.331 81.321 110.068 81.321H26.6131C24.3503 81.321 22.4746 79.4641 22.4746 77.1881V21.7833C22.4746 19.5072 24.3206 17.6504 26.6131 17.6504H110.068C112.331 17.6504 114.177 19.5072 114.177 21.7833Z",
    fill: "url(#paint0_linear_9544_25013)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.177 21.7833V27.9826H22.4746V21.7833C22.4746 19.5072 24.3206 17.6504 26.6131 17.6504H110.068C112.331 17.6504 114.177 19.5072 114.177 21.7833Z",
    fill: "#D5DDEA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2513 24.3588C29.1064 24.3588 29.7996 23.6616 29.7996 22.8015C29.7996 21.9414 29.1064 21.2441 28.2513 21.2441C27.3963 21.2441 26.7031 21.9414 26.7031 22.8015C26.7031 23.6616 27.3963 24.3588 28.2513 24.3588Z",
    fill: "#989FB0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3119 24.3588C34.167 24.3588 34.8601 23.6616 34.8601 22.8015C34.8601 21.9414 34.167 21.2441 33.3119 21.2441C32.4568 21.2441 31.7637 21.9414 31.7637 22.8015C31.7637 23.6616 32.4568 24.3588 33.3119 24.3588Z",
    fill: "#989FB0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3451 24.3588C39.2002 24.3588 39.8933 23.6616 39.8933 22.8015C39.8933 21.9414 39.2002 21.2441 38.3451 21.2441C37.49 21.2441 36.7969 21.9414 36.7969 22.8015C36.7969 23.6616 37.49 24.3588 38.3451 24.3588Z",
    fill: "#989FB0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.459 64H89.459",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53.459 71H82.459",
    stroke: "#D5DDEA",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3938 49.6057V52.6904H56.518V55.6553H53.0048V52.6904H45.2637V49.1565L52.4391 39.1237H56.5478V49.6356H58.3938V49.6057ZM53.0048 43.2267L48.5388 49.6057H53.0048V43.2267Z",
    fill: "url(#paint1_linear_9544_25013)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2067 55.9847C63.4553 55.9847 60.1504 52.6904 60.1504 47.3595C60.1504 42.0287 63.4255 38.7344 67.2067 38.7344C70.9879 38.7344 74.263 42.0287 74.263 47.3595C74.263 52.6904 70.9879 55.9847 67.2067 55.9847ZM67.2067 52.8102C68.9633 52.8102 70.72 51.0432 70.72 47.3895C70.72 43.7358 68.9633 41.9688 67.2067 41.9688C65.4501 41.9688 63.6934 43.7358 63.6934 47.3895C63.6934 51.0432 65.4501 52.8102 67.2067 52.8102Z",
    fill: "url(#paint2_linear_9544_25013)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2067 55.9847C79.4553 55.9847 76.1504 52.6904 76.1504 47.3595C76.1504 42.0287 79.4255 38.7344 83.2067 38.7344C86.9879 38.7344 90.263 42.0287 90.263 47.3595C90.263 52.6904 86.9879 55.9847 83.2067 55.9847ZM83.2067 52.8102C84.9633 52.8102 86.72 51.0432 86.72 47.3895C86.72 43.7358 84.9633 41.9688 83.2067 41.9688C81.4501 41.9688 79.6934 43.7358 79.6934 47.3895C79.6934 51.0432 81.4501 52.8102 83.2067 52.8102Z",
    fill: "url(#paint3_linear_9544_25013)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.123 93.5546L90.1758 73.6236L94.7486 69.0508L114.68 88.9976L110.123 93.5546Z",
    fill: "#858B9B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M117.056 100.569L101.761 85.2735C100.483 83.9962 100.483 81.9148 101.761 80.6376C103.038 79.3604 105.119 79.3604 106.397 80.6376L121.692 95.9328C122.969 97.21 122.969 99.2914 121.692 100.569C120.414 101.846 118.333 101.846 117.056 100.569Z",
    fill: "#858B9B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M115.969 101.545L96.2902 81.8667C95.8329 81.4094 95.8329 80.6683 96.2902 80.1953L101.32 75.1652C101.778 74.7079 102.519 74.7079 102.992 75.1652L122.67 94.8439C123.128 95.3012 123.128 96.0423 122.67 96.5154L117.64 101.545C117.167 102.003 116.426 102.003 115.969 101.545Z",
    fill: "url(#paint4_linear_9544_25013)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5952 9.40039C46.7181 9.40039 29.7988 26.3197 29.7988 47.1968C29.7988 68.0581 46.7181 84.9931 67.5794 84.9931C88.4565 84.9931 105.376 68.0739 105.376 47.1968C105.376 26.3197 88.4565 9.40039 67.5952 9.40039ZM67.5952 77.9921C50.8336 77.9921 37.2572 64.1949 37.2572 47.181C37.2572 30.1671 50.8336 16.3857 67.5952 16.3857C84.3568 16.3857 97.9332 30.1829 97.9332 47.1968C97.9332 64.2107 84.341 77.9921 67.5952 77.9921Z",
    fill: "url(#paint5_linear_9544_25013)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9544_25013",
    x: 0.474609,
    y: 6.65039,
    width: 135.703,
    height: 107.67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9544_25013"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9544_25013",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9544_25013",
    x1: 68.2959,
    y1: 16.1776,
    x2: 68.2959,
    y2: 82.0074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9544_25013",
    x1: 74.4232,
    y1: 38.7344,
    x2: 77.7224,
    y2: 55.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9544_25013",
    x1: 74.4232,
    y1: 38.7344,
    x2: 77.7224,
    y2: 55.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9544_25013",
    x1: 74.4232,
    y1: 38.7344,
    x2: 77.7224,
    y2: 55.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9544_25013",
    x1: 95.9349,
    y1: 88.3583,
    x2: 123.018,
    y2: 88.3583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9544_25013",
    x1: 29.7642,
    y1: 47.205,
    x2: 105.39,
    y2: 47.205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError400);
export default __webpack_public_path__ + "static/media/error-400.c342af3f.svg";
export { ForwardRef as ReactComponent };